import React from 'react';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import PlacementInfo from './placementInfo';
import PlacementCardLayout from './placementCardLayout';

interface TransferredInPlacementCardProps {
  placement: AssociateProfilePlacement;
}

const TransferredInPlacementCard = ({ placement }: TransferredInPlacementCardProps) => {
  return (
    <PlacementCardLayout placement={placement}>
      <PlacementInfo label="Injury" value={placement.injury} />
      <PlacementInfo label="Transferred from" value={placement.transferredFrom} />
      <PlacementInfo label="Transfer Date" value={new Date(placement.transferAt).toLocaleDateString()} />
      <PlacementInfo label="Time In Transfer" value={placement.timeInStatus} />
      <PlacementInfo label="Transferred By" value={placement.updatedBy} />
    </PlacementCardLayout>
  );
};

export default TransferredInPlacementCard;
